import { render, staticRenderFns } from "./ContentBrowser.vue?vue&type=template&id=6d28c716&scoped=true"
import script from "./ContentBrowser.vue?vue&type=script&lang=js"
export * from "./ContentBrowser.vue?vue&type=script&lang=js"
import style0 from "./ContentBrowser.vue?vue&type=style&index=0&id=6d28c716&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28c716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d28c716')) {
      api.createRecord('6d28c716', component.options)
    } else {
      api.reload('6d28c716', component.options)
    }
    module.hot.accept("./ContentBrowser.vue?vue&type=template&id=6d28c716&scoped=true", function () {
      api.rerender('6d28c716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentBrowser.vue"
export default component.exports